import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, EASE } from "./Reveal";

const QS = [
    {
        q: "What is MoneyMuscle?",
        a: "An easy to use personal fitness and finance aid - workouts, meal plans, budgeting and more, all in one app.",
    },
    {
        q: "When does it launch?",
        a: "The first release is in final polish. Waitlist members get access before anyone else.",
    },
    {
        q: "What will it cost?",
        a: "MoneyMuscle will be offered free, in full, to early supporters for a limited time, with opportunities to extend through feedback and referral programs.",
    },
    {
        q: "Which platforms?",
        a: "iOS and Android. Join the waitlist and you'll hear the moment your platform is ready.",
    },
    {
        q: "Is my data private?",
        a: "Yes. Only you can see your workouts, meals and money.",
    },
];

const Item = ({ q, a, index, open, onToggle }) => (
    <div className="border-b border-white/[0.07]">
        <button
            type="button"
            data-testid={`faq-question-${index}`}
            onClick={onToggle}
            className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors duration-300 hover:text-acid md:py-7"
        >
            <span className="font-display text-lg font-bold text-white md:text-2xl">
                {q}
            </span>
            <motion.span
                animate={{ rotate: open ? 45 : 0 }}
                transition={{ duration: 0.35, ease: EASE }}
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/15 text-white"
            >
                <Plus size={16} />
            </motion.span>
        </button>
        <AnimatePresence initial={false}>
            {open && (
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: EASE }}
                    className="overflow-hidden"
                >
                    <p className="max-w-2xl pb-7 text-[15px] leading-relaxed text-[#8f8f89] md:text-base">
                        {a}
                    </p>
                </motion.div>
            )}
        </AnimatePresence>
    </div>
);

export const FAQ = () => {
    const [open, setOpen] = useState(0);

    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative scroll-mt-20 px-5 pb-28 pt-4 md:pb-36"
        >
            <div className="mx-auto max-w-3xl">
                <Reveal className="mb-10 text-center md:mb-14">
                    <h2 className="font-display text-4xl font-black tracking-[-0.02em] text-white md:text-5xl">
                        About us.
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <div className="border-t border-white/[0.07]">
                        {QS.map((item, i) => (
                            <Item
                                key={i}
                                index={i}
                                q={item.q}
                                a={item.a}
                                open={open === i}
                                onToggle={() => setOpen(open === i ? -1 : i)}
                            />
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
